/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>限时秒杀</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container class="filter_con">
         <el-tabs v-model="activeName" @tab-click="tabhandleClick">
            <el-tab-pane name=1>
                <div class="tabTitle" slot="label"><i>08:00</i> <i>{{compareTime('08:00',1)}}</i></div>
                 <el-row class="right_product" :gutter="20" v-loading="loading">
                    <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                        ><div class="product_item selectItemCss_ls">
                        <div class="p-img">
                            <router-link
                            :to="`/goodsdetail?id=${item.commodity.id}`"
                            class="item_link"
                            >
                            <el-image
                                class="img-responsive"
                                :src="`${item.commodity.photos}`"
                                style="display: block"
                            ></el-image>
                            </router-link>
                        </div>
                        <div class="pro_name">
                            <router-link  :to="`/goodsdetail?id=${item.commodity.id}`">{{item.commodity.name}}</router-link>
                        </div>
                        <div class="pro_progress">
                            <!-- <el-progress :percentage="Number(item.activityNumQuantity)-Number(item.activityPointsProductNum)" :stroke-width="14" :color="customColors"></el-progress> -->
                            <!-- <el-progress :percentage="compareTime('08:00')=='已结束'?'已售':Number(item.activityNumQuantity)-Number(item.activityPointsProductNum)" :stroke-width="14" :color="customColors"></el-progress> -->
                        </div>
                        <div class="pro_price_add">
                            <div class="now_price"><i>¥</i><span>{{(item.commodity.realprice!=null && item.commodity.realprice!="")?item.commodity.realprice: item.commodity.marketprice}}</span></div>
                            <div class="cart add-to-cart">
                            <a
                                :title="item.isEnd?'已结束':(nostart?'即将开始':'查看详情')"
                                href="javascript:;"
                                data-item_id="1207"
                                @click="nostart?noStartTips():$router.push(`/goodsdetail?id=${item.commodity.id}`)"
                                >{{item.isEnd?'已结束':(nostart?'即将开始':'查看详情')}}</a
                            >
                            </div>
                        </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="nodate" v-if="rightGoodsList.length>0?false:true">
                            <div class="first">对不起，目前没有秒杀商品!</div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name=2>
                <div class="tabTitle" slot="label"><i>10:00</i> <i>{{compareTime('10:00',2)}}</i></div>
                <el-row class="right_product" :gutter="20" v-loading="loading">
                    <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                        ><div class="product_item selectItemCss_ls">
                        <div class="p-img">
                            <router-link
                            :to="`/goodsdetail?id=${item.commodity.id}`"
                            class="item_link"
                            >
                            <el-image
                                class="img-responsive"
                                :src="`${item.commodity.photos}`"
                                style="display: block"
                            ></el-image>
                            </router-link>
                        </div>
                        <div class="pro_name">
                            <router-link  :to="`/goodsdetail?id=${item.commodity.id}`">{{item.commodity.name}}</router-link>
                        </div>
                         <div class="pro_progress">
                            <!-- <el-progress :percentage="100" :stroke-width="14" :color="customColors"></el-progress> -->
                        </div>
                        <div class="pro_price_add">
                            <div class="now_price"><i>¥</i><span>{{(item.commodity.realprice!=null && item.commodity.realprice!="")?item.commodity.realprice: item.commodity.marketprice}}</span></div>
                            <div class="cart add-to-cart">
                            <a
                                :title="item.isEnd?'已结束':(nostart?'即将开始':'查看详情')"
                                href="javascript:;"
                                data-item_id="1207"
                                @click="nostart?noStartTips():$router.push(`/goodsdetail?id=${item.commodity.id}`)"
                                >{{item.isEnd?'已结束':(nostart?'即将开始':'查看详情')}}</a
                            >
                            </div>
                        </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="nodate" v-if="rightGoodsList.length>0?false:true">
                            <div class="first">对不起，目前没有秒杀商品!</div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name=3>
                <div class="tabTitle" slot="label"><i>12:00</i> <i>{{compareTime('12:00',3)}}</i></div>
                <el-row class="right_product" :gutter="20" v-loading="loading">
                    <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                        ><div class="product_item selectItemCss_ls">
                        <div class="p-img">
                            <router-link
                            :to="`/goodsdetail?id=${item.commodity.id}`"
                            class="item_link"
                            >
                            <el-image
                                class="img-responsive"
                                :src="`${item.commodity.photos}`"
                                style="display: block"
                            ></el-image>
                            </router-link>
                        </div>
                        <div class="pro_name">
                            <router-link  :to="`/goodsdetail?id=${item.commodity.id}`">{{item.commodity.name}}</router-link>
                        </div>
                         <div class="pro_progress">
                            <!-- <el-progress :percentage="100" :stroke-width="14" :color="customColors"></el-progress> -->
                        </div>
                        <div class="pro_price_add">
                            <div class="now_price"><i>¥</i><span>{{(item.commodity.realprice!=null && item.commodity.realprice!="")?item.commodity.realprice: item.commodity.marketprice}}</span></div>
                            <div class="cart add-to-cart">
                            <a
                                :title="item.isEnd?'已结束':(nostart?'即将开始':'查看详情')"
                                href="javascript:;"
                                data-item_id="1207"
                                @click="nostart?noStartTips():$router.push(`/goodsdetail?id=${item.commodity.id}`)"
                                >{{item.isEnd?'已结束':(nostart?'即将开始':'查看详情')}}</a
                            >
                            </div>
                        </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="nodate" v-if="rightGoodsList.length>0?false:true">
                            <div class="first">对不起，目前没有秒杀商品!</div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name=4>
                <div class="tabTitle" slot="label"><i>14:00</i> <i>{{compareTime('14:00',4)}}</i></div>
                <el-row class="right_product" :gutter="20" v-loading="loading">
                    <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                        ><div class="product_item selectItemCss_ls">
                        <div class="p-img">
                            <router-link
                            :to="`/goodsdetail?id=${item.commodity.id}`"
                            class="item_link"
                            >
                            <el-image
                                class="img-responsive"
                                :src="`${item.commodity.photos}`"
                                style="display: block"
                            ></el-image>
                            </router-link>
                        </div>
                        <div class="pro_name">
                            <router-link  :to="`/goodsdetail?id=${item.commodity.id}`">{{item.commodity.name}}</router-link>
                        </div>
                         <div class="pro_progress">
                            <!-- <el-progress :percentage="100" :stroke-width="14" :color="customColors"></el-progress> -->
                        </div>
                        <div class="pro_price_add">
                            <div class="now_price"><i>¥</i><span>{{(item.commodity.realprice!=null && item.commodity.realprice!="")?item.commodity.realprice: item.commodity.marketprice}}</span></div>
                            <div class="cart add-to-cart">
                            <a
                                :title="item.isEnd?'已结束':(nostart?'即将开始':'查看详情')"
                                href="javascript:;"
                                data-item_id="1207"
                                @click="nostart?noStartTips():$router.push(`/goodsdetail?id=${item.commodity.id}`)"
                                >{{item.isEnd?'已结束':(nostart?'即将开始':'查看详情')}}</a
                            >
                            </div>
                        </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="nodate" v-if="rightGoodsList.length>0?false:true">
                            <div class="first">对不起，目前没有秒杀商品!</div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
             <el-tab-pane name=5>
                <div class="tabTitle" slot="label"><i>16:00</i> <i>{{compareTime('16:00',5)}}</i></div>
                <el-row class="right_product" :gutter="20" v-loading="loading">
                    <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                        ><div class="product_item selectItemCss_ls">
                        <div class="p-img">
                            <router-link
                            :to="`/goodsdetail?id=${item.commodity.id}`"
                            class="item_link"
                            >
                            <el-image
                                class="img-responsive"
                                :src="`${item.commodity.photos}`"
                                style="display: block"
                            ></el-image>
                            </router-link>
                        </div>
                        <div class="pro_name">
                            <router-link  :to="`/goodsdetail?id=${item.commodity.id}`">{{item.commodity.name}}</router-link>
                        </div>
                         <div class="pro_progress">
                            <!-- <el-progress :percentage="100" :stroke-width="14" :color="customColors"></el-progress> -->
                        </div>
                        <div class="pro_price_add">
                            <div class="now_price"><i>¥</i><span>{{(item.commodity.realprice!=null && item.commodity.realprice!="")?item.commodity.realprice: item.commodity.marketprice}}</span></div>
                            <div class="cart add-to-cart">
                            <a
                                :title="item.isEnd?'已结束':(nostart?'即将开始':'查看详情')"
                                href="javascript:;"
                                data-item_id="1207"
                                @click="nostart?noStartTips():$router.push(`/goodsdetail?id=${item.commodity.id}`)"
                                >{{item.isEnd?'已结束':(nostart?'即将开始':'查看详情')}}</a
                            >
                            </div>
                        </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="nodate" v-if="rightGoodsList.length>0?false:true">
                            <div class="first">对不起，目前没有秒杀商品!</div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name=6>
                <div class="tabTitle" slot="label"><i>18:00</i> <i>{{compareTime('18:00',6)}}</i></div>
                <el-row class="right_product" :gutter="20" v-loading="loading">
                    <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                        ><div class="product_item selectItemCss_ls">
                        <div class="p-img">
                            <router-link
                            :to="`/goodsdetail?id=${item.commodity.id}`"
                            class="item_link"
                            >
                            <el-image
                                class="img-responsive"
                                :src="`${item.commodity.photos}`"
                                style="display: block"
                            ></el-image>
                            </router-link>
                        </div>
                        <div class="pro_name">
                            <router-link  :to="`/goodsdetail?id=${item.commodity.id}`">{{item.commodity.name}}</router-link>
                        </div>
                         <div class="pro_progress">
                            <!-- <el-progress :percentage="100" :stroke-width="14" :color="customColors"></el-progress> -->
                        </div>
                        <div class="pro_price_add">
                            <div class="now_price"><i>¥</i><span>{{(item.commodity.realprice!=null && item.commodity.realprice!="")?item.commodity.realprice: item.commodity.marketprice}}</span></div>
                            <div class="cart add-to-cart">
                            <a
                                :title="item.isEnd?'已结束':(nostart?'即将开始':'查看详情')"
                                href="javascript:;"
                                data-item_id="1207"
                                @click="nostart?noStartTips():$router.push(`/goodsdetail?id=${item.commodity.id}`)"
                                >{{item.isEnd?'已结束':(nostart?'即将开始':'查看详情')}}</a
                            >
                            </div>
                        </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="nodate" v-if="rightGoodsList.length>0?false:true">
                            <div class="first">对不起，目前没有秒杀商品!</div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name=7>
                <div class="tabTitle" slot="label"><i>20:00</i> <i>{{compareTime('20:00',7)}}</i></div>
                <el-row class="right_product" :gutter="20" v-loading="loading">
                    <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                        ><div class="product_item selectItemCss_ls">
                        <div class="p-img">
                            <router-link
                            :to="`/goodsdetail?id=${item.commodity.id}`"
                            class="item_link"
                            >
                            <el-image
                                class="img-responsive"
                                :src="`${item.commodity.photos}`"
                                style="display: block"
                            ></el-image>
                            </router-link>
                        </div>
                        <div class="pro_name">
                            <router-link  :to="`/goodsdetail?id=${item.commodity.id}`">{{item.commodity.name}}</router-link>
                        </div>
                         <div class="pro_progress">
                            <!-- <el-progress :percentage="100" :stroke-width="14" :color="customColors"></el-progress> -->
                        </div>
                        <div class="pro_price_add">
                            <div class="now_price"><i>¥</i><span>{{(item.commodity.realprice!=null && item.commodity.realprice!="")?item.commodity.realprice: item.commodity.marketprice}}</span></div>
                            <div class="cart add-to-cart">
                            <a
                                :title="item.isEnd?'已结束':(nostart?'即将开始':'查看详情')"
                                href="javascript:;"
                                data-item_id="1207"
                                @click="nostart?noStartTips():$router.push(`/goodsdetail?id=${item.commodity.id}`)"
                                >{{item.isEnd?'已结束':(nostart?'即将开始':'查看详情')}}</a
                            >
                            </div>
                        </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="nodate" v-if="rightGoodsList.length>0?false:true">
                            <div class="first">对不起，目前没有秒杀商品!</div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
             <el-tab-pane name=8>
                <div class="tabTitle" slot="label"><i>22:00</i> <i>{{compareTime('22:00',8)}}</i></div>
                <el-row class="right_product" :gutter="20" v-loading="loading">
                    <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                        ><div class="product_item selectItemCss_ls">
                        <div class="p-img">
                            <router-link
                            :to="`/goodsdetail?id=${item.commodity.id}`"
                            class="item_link"
                            >
                            <el-image
                                class="img-responsive"
                                :src="`${item.commodity.photos}`"
                                style="display: block"
                            ></el-image>
                            </router-link>
                        </div>
                        <div class="pro_name">
                            <router-link  :to="`/goodsdetail?id=${item.commodity.id}`">{{item.commodity.name}}</router-link>
                        </div>
                         <div class="pro_progress">
                            <!-- <el-progress :percentage="100" :stroke-width="14" :color="customColors"></el-progress> -->
                        </div>
                        <div class="pro_price_add">
                            <div class="now_price"><i>¥</i><span>{{(item.commodity.realprice!=null && item.commodity.realprice!="")?item.commodity.realprice: item.commodity.marketprice}}</span></div>
                            <div class="cart add-to-cart">
                            <a
                                :title="item.isEnd?'已结束':(nostart?'即将开始':'查看详情')"
                                href="javascript:;"
                                data-item_id="1207"
                                @click="nostart?noStartTips():$router.push(`/goodsdetail?id=${item.commodity.id}`)"
                                >{{item.isEnd?'已结束':(nostart?'即将开始':'查看详情')}}</a
                            >
                            </div>
                        </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="nodate" v-if="rightGoodsList.length>0?false:true">
                            <div class="first">对不起，目前没有秒杀商品!</div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
        <!-- <el-main class="rightaside"> -->
		  <!-- <el-row>
		  	<div class="nodate" v-if="rightGoodsList.length>0?false:true">
		  		<div class="first">对不起，目前没有秒杀商品!</div>
		  	</div>
		  </el-row> -->
            <!-- <el-row>
                <el-col :span="24" class="pagination">
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                </el-col>
            </el-row> -->
        <!-- </el-main> -->
      </el-container>

    <!-- 加入购物车弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">已成功加入购物车！</div>
        <div>{{ addGoodsName }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">继续购物</el-button>
          <el-button type="primary" @click="$router.push('/shoppingcart')"
            >去购物车结算</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import hotGoods from '@/components/hotGoods'
import "@/assets/css/base.css";
import { commoditylist,addShoppingCart,categorylist,seckillCommodityList } from "@/api/xunyou";
import Pagination from '@/components/Pagination'
import {getDateTimeNow} from '@/utils/util'
export default {
  data() {
    return {
      customColors:'#78b942',
      activeName:'1',
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      loading:false,
      centerDialogVisible: false,
      successInfo: true,
      addGoodsName: "",
      rightGoodsList:[],
      currentTimeTab:'08:00',// 当前停留的时间tab
      nostart:true,
      isEnd:false
    };
  },
  // 注册组件
  components: {hotGoods,Pagination},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    let hour = Number(this.changeTime().time.slice(11,13))
    if(hour%2==0){
         this.nowtime =  this.changeTime().time.slice(0,14)+'00:00'
    }else{
        let time = this.changeTime().time.slice(0,11)
        this.nowtime =  `${time}${hour-1}:00:00`
    }
  },
  mounted(){
    this.getCommoditylist( this.nowtime)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        changeTime(t){
            if(t==undefined){
                t=new Date().getTime()
            }
            var res={}
            res.year=new Date(t).getFullYear()
            res.month=new Date(t).getMonth()+1
            res.month=res.month>9?res.month:'0'+res.month,
            res.day=new Date(t).getDate()
            res.day=res.day>9?res.day:'0'+res.day,
            res.hour=new Date(t).getHours()
            res.hour=res.hour>9?res.hour:'0'+res.hour,
            res.minute=new Date(t).getMinutes()
            res.minute=res.minute>9?res.minute:'0'+res.minute,
            res.second=new Date(t).getSeconds()
            res.second=res.second>9?res.second:'0'+res.second,
            res.time=res.year+'-'+res.month+'-'+res.day+' '+res.hour+':'+res.minute+':'+res.second
            return res
        },
      //   切换tab
      tabhandleClick(tab, event) {
        this.currentTimeTab = this.getTimeTab(this.activeName)
        this.nostart = this.compareTime(this.currentTimeTab,this.activeName)!='即将开始'?false:true
        this.getCommoditylist()
      },

    // 比较时间
    compareTime(time,type){
        let pageTime = new Date(`${getDateTimeNow()} ${time}:00`).getTime()
        let nextTwoHour = pageTime+(60*60*1000)*2 // 当前tab时间+2个小时
        let nowTime = new Date().getTime()
        if(nowTime<pageTime){
            return '即将开始'
        }
        else if(pageTime<nowTime){
            if(nowTime<=nextTwoHour){
                this.activeName = String(type) 
                return '抢购中'
            }else{
                return '已结束'
            }
        }
    },

    noStartTips(){
        this.$message.success("请稍后，秒杀即将开始");
    },

    // 获取时间
    getTimeTab(status){
       switch(status) {
            case '1': 
                return  '08:00'
                break;
            case '2': 
                 return '10:00'
                break;
            case '3':
                 return '12:00'
                break;
            case '4': 
                 return '14:00'
                 break;
            case '5': 
                 return '16:00'
                 break;
            case '6': 
                 return '18:00'
                 break;
            case '7': 
                 return '20:00'
                 break;
            case '8': 
                 return '22:00'
                 break;
            default:                
                return '--'
        } 
    },
     // 商品列表查询
    getCommoditylist(nowtime) {
      this.loading = true;
      seckillCommodityList({
        activityTypeId:6, // 秒杀类型
        activityStarttime:nowtime?nowtime:`${getDateTimeNow()} ${this.currentTimeTab}:00`, // 活动开始时间
      })
        .then((res) => {
          this.loading = false;
          this.rightGoodsList = res.rows;
          this.rightGoodsList.forEach((item)=>{
              if(item.commodity.bxyMarketing){
                  let activityEndtime = new Date(item.commodity.bxyMarketing.activityEndtime).getTime()
                  let nowTime = new Date().getTime()
                  item.isEnd = nowTime>activityEndtime?true:false // 该商品是否已经结束
                //   this.currentTimeTab = this.getTimeTab(this.activeName)
                  this.nostart = this.compareTime(this.currentTimeTab,this.activeName)!='即将开始'?false:true
              }
          })
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("查询秒杀列表失败，请稍后再试！");
        });
    },
    addCart(id,name,specificationlist,status,approvalStatus) {
        if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
        if(status==1&&approvalStatus==1){
             addShoppingCart({
            cid: id,
            uid: this.userInfo.userId,
            number: 1,
            bxysid:specificationlist
        })
            .then((res) => {
                if (res.code == 0) {            
                console.log("res", res);
                this.addGoodsName = name;
                this.centerDialogVisible = true;
            
                }
            })
            .catch((err) => {
            this.loading = false;
            this.$message.error("添加购物车失败，请稍后再试！");
            });
        }else{
            this.$message.error('暂时缺货')
			return
        }
     
    },
  },
};
</script>

<style scoped lang='less'>
.breakcrumbHeader {
  margin: 15px 0;
}
.labelTitle {
  text-align: left;
  padding-left: 15px;
  font-weight: bold;
  color: #666;
  font-size: 14px;
}
.pro_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  margin: 10px 0;
  height: 40px;
}
.img-responsive {
//   /* width: 100%; */
//   width: 200px;
  height: 200px;
}

/* 右边 */
.right_product {
  padding: 20px;
}
.right_product .product_item {
  margin-bottom: 20px;
  border: 1px solid #fff;
  border-color: #e9e9e9;
  -webkit-box-shadow: 0 0 2px 2px #f8f8f8;
  box-shadow: 0 0 2px 2px #f8f8f8;
  padding: 10px;
  box-sizing: border-box;
}
.product_item:hover img {
  opacity: 0.7;
}
.pro_price_add {
  display: flex;
  justify-content: space-around;
}
.pro_progress{
    margin:10px 0;
    /deep/.el-progress__text {
        font-size: 14px !important;
    }
}
.cart.add-to-cart,
div.now_price {
  flex: 1;
  font-weight: bold;
  border: 1px solid #78b942;
  padding: 8px 0;
  text-align: center;
}
div.now_price {
  color: white;
  background: #78b942;
  border: 1px solid #78b942;
}
.dialog-footer {
  margin-top: 20px;
  display: block;
}
.addGoodsInfo {
  font-size: 24px;
}
.addCartBox .el-button--primary {
  color: #fff;
  background-color: #78b942;
  border-color: #e65d00;
}
.filter_con{
    /deep/.el-tabs.el-tabs--top,
    /deep/.el-tabs__nav.is-top {
        width: 100%;
        .el-tabs__item.is-top{
            height: 100%;
            width: 150px;
            text-align: center;
            font-size: 15px;

        }
        .el-tabs__active-bar{
            background: #78b942;
        }
        .el-tabs__item.is-top.is-active{
            background: #78b942;
            color: white;
        }
    }
    .tabTitle{
        margin-bottom: 15px;
        i{
            display: block;
            height: 25px;
        }
    }

}


.nodate{
    text-align: center;
    padding: 10%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}

.pagination{
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #78b942;
      color: #FFF;
      width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
      background-color: transparent;
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/spike/index.vue